<template>
  <div>
    <div class="px-8 d-flex text-h6 font-weight-regular" v-if="!isDiff">
      {{ event.title }}
    </div>

    <div
      v-else
      :class="$style.newBg"
      class="d-flex text-h6 font-weight-regular align-center primary--text pl-2"
    >
      <v-icon small color="primary" class="pr-2">mdi-alert-octagram</v-icon>
      {{ event.title }}
    </div>
  </div>
</template>

<script>
import { get } from 'vuex-pathify'

export default {
  name: 'TrafficMessageSubjectText',

  computed: {
    event: get('event/selectedEvent'),
    isDiff: get('trafficMessage/diffSubjectCount')
  }
}
</script>

<style lang="scss" module>
.newBg {
  background: rgba(#0034f9, 0.06);
}
</style>
